<p-toast position="top-center" key="tc"></p-toast>
<p-confirmdialog />

<p-card header="Utente Autenticato">
  <p-tabs class="min-h-104" [(value)]="tabsId">
    <p-tablist>
      <p-tab [value]="0">Dati</p-tab>
      <p-tab [value]="1">Configurazione</p-tab>
      <p-tab [value]="2">Password</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <div class="grid grid-cols-5 items-center gap-3">
          <label class="col-1 text-left" for="user-name">UserName/E-Mail</label>
          <input pInputText id="user-name" class="col-span-2" [(ngModel)]="user.userName" [disabled]="true" />

          <label class="col-1 text-left" for="display-name">Nome</label>
          <input pInputText id="display-name" class="col-span-2" [(ngModel)]="user.name" />

          <label class="col-1 text-left" for="family-name">Cognome</label>
          <input pInputText id="family-name" class="col-span-2" [(ngModel)]="user.familyName" />

          <label class="col-1 text-left" for="mass">Peso</label>
          <p-inputnumber inputId="mass" [(ngModel)]="user.mass" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="3" />
          <label class="text-left">Kg</label>

        </div>
      </p-tabpanel>

      <p-tabpanel [value]="1">
        <div class="grid grid-cols-5 content-start gap-3">
          <div class="col-1 flex flex-col">
            <label class="text-left font-semibold">Ruolo</label>
            <p-table [value]="ruoli"
                     stripedRows
                     size="small"
                     [scrollable]="true"
                     scrollHeight="400px">
              <ng-template #body let-role>
                <tr>
                  <td>{{ role }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="col-span-2 flex flex-col">
            <label class="text-left font-semibold">Organizzazioni</label>
            <p-table [value]="user.organizations"
                     dataKey="organizationId"
                     stripedRows
                     [expandedRowKeys]="expandedRows"
                     size="small"
                     [scrollable]="true"
                     scrollHeight="400px">
              <ng-template #body let-organization let-expanded="expanded">
                <tr>
                  <td style="width:5rem">
                    <p-button type="button" pRipple [pRowToggler]="organization" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" />
                  </td>
                  <td>{{ organization.name }}</td>
                  <td style="width:3rem">
                    <p-button *ngIf="user.organizations.length > 1" icon="fas fa-xmark" [text]="true" (click)="onRemoveOrganization($event, organization)" />
                  </td>
                </tr>
              </ng-template>
              <ng-template #expandedrow let-organization>
                <tr>
                  <td colspan="7">
                    <p-table [value]="organization.teams" dataKey="teamId" size="small">
                      <ng-template #header>
                        <tr>
                          <th>Squadra</th>
                          <th style="width:3rem"></th>
                        </tr>
                      </ng-template>
                      <ng-template #body let-team>
                        <tr>
                          <td>{{ team.name }}</td>
                          <td></td>
                        </tr>
                      </ng-template>
                      <ng-template #emptymessage>
                        <tr>
                          <td colspan="6">There are no order for this product yet.</td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-tabpanel>

      <p-tabpanel [value]="2">
        <div class="grid grid-cols-5 items-center justify-start gap-3">
          <label class="col-start-1 text-left">Password Attuale</label>
          <p-password [(ngModel)]="oldValue" [toggleMask]="true" [feedback]="false" fluid />

          <label class="col-start-1 text-left">Nuova Password</label>
          <p-password [(ngModel)]="newValue" [toggleMask]="true" fluid>
            <ng-template #footer>
              <p-divider />
              <ul class="my-0 pl-2 text-xs leading-normal">
                <li>Deve contenere almeno una lettera minuscola</li>
                <li>Deve contenere almeno una lettera maiuscola</li>
                <li>Deve contenere almeno un numero</li>
                <li>Deve essere lunga almeno 8 caratteri</li>
              </ul>
            </ng-template>
          </p-password>

          <label class="col-start-1 text-left">Conferma Password</label>
          <p-password [(ngModel)]="chkValue" [toggleMask]="true" fluid>
            <ng-template #footer>
              <p-divider />
              <ul class="my-0 pl-2 text-xs leading-normal">
                <li>Deve contenere almeno una lettera minuscola</li>
                <li>Deve contenere almeno una lettera maiuscola</li>
                <li>Deve contenere almeno un numero</li>
                <li>Deve essere lunga almeno 8 caratteri</li>
              </ul>
            </ng-template>
          </p-password>

          <p-button class="col-start-2" label="Cambia Password" (click)="onChange()" fluid />
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <ng-template #footer>
    <div class="col-span-3 ml-auto flex gap-2">
      <p-button severity="primary" label="Salva" icon="fas fa-check" (click)="onSave()" />
      <p-button severity="secondary" label="Annulla" icon="fas fa-xmark" (click)="onCancel()" />
    </div>
  </ng-template>
</p-card>
